import { DeleteOutlined } from "@ant-design/icons";
import { useCan, useDelete, useNavigation } from "@refinedev/core";
import { Button, FormInstance, Popconfirm, Space, Tooltip } from "antd";

export const ActionsColumn: React.FC<{ record: any; form: FormInstance<any>; refetch: () => void }> = ({
    record,
    form,
    refetch,
}) => {
    const { mutateAsync: deleteExplore } = useDelete();

    const { data: dataCanDelete } = useCan({
        resource: "exploration",
        action: "delete",
        params: {
            productCode: record.product.code,
        },
    });
    const handleDelete = async (id: any) => {
        form?.setFieldValue("form_loading", true);
        await deleteExplore({
            dataProviderName: "nestjsx",
            id,
            resource: `explorations`,
            successNotification: () => {
                return {
                    type: "success",
                    message: "Delete firebase exploration successfully!",
                };
            },
            errorNotification: () => {
                return {
                    type: "error",
                    message: "Delete firebase exploration failed!",
                };
            },
        });
        form?.setFieldValue("form_loading", false);
        refetch();
    };
    return (
        <Space
            className="ml-4"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <Popconfirm
                title="Are you sure delete this exploration?"
                onConfirm={() => {
                    handleDelete(record.id);
                }}
            >
                <Tooltip title={dataCanDelete?.can ? "Delete" : dataCanDelete?.reason}>
                    <Button danger icon={<DeleteOutlined />} size="small" disabled={!dataCanDelete?.can} />
                </Tooltip>
            </Popconfirm>
        </Space>
    );
};
